import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import React, { useState, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";

const AfterUploadCompletes = ({
  displayLink,
  setDisplayLink,
  displaySendAnotherEmail,
  setDisplaySendAnotherEmail,
  thankyouPageRedirect,
  setThankyouPageRedirect,
  setRedirectLink,
  redirectLink,
  setUpdateBeforeSave,
  emptyOrInvalidUrl,
  setEmptyOrInvalidUrl,
  deleteMailLink,
  setDeleteMailLink,
  viewMode,
  setViewMode,
}) => {
  const { isPremium } = useUser();
  const { setModal } = useModal();
  const { getTextByKey, getHtmlByKey } = useContent();
  const [tempFocuseRedirectUrl, setTempFocuseRedirectUrl] = useState(null);
  const [tempBlurRedirectUrl, setTempBlurRedirectUrl] = useState(null);
  const [updateAfterUpload, setUpdateAfterUpload] = useState(false);

  useEffect(() => {
    if (tempBlurRedirectUrl !== tempFocuseRedirectUrl && thankyouPageRedirect) {
      setUpdateAfterUpload(true);
    }
  }, [tempBlurRedirectUrl]);

  const handleChangeThankYouPage = () => {
    if (isPremium()) {
      const newThankyouPageRedirect = !thankyouPageRedirect;

      setThankyouPageRedirect(newThankyouPageRedirect);
      setDisplaySendAnotherEmail(false);
      setDisplayLink(false);
      setEmptyOrInvalidUrl(false);
      setDeleteMailLink(false);
      if (!newThankyouPageRedirect) {
        setUpdateAfterUpload(true);
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  const handleChangeDeleteMailLink = () => {
    setDeleteMailLink((prev) => !prev);
    setThankyouPageRedirect(false);
    setUpdateAfterUpload(true);
  };

  const handleChangeSendAnotherEmail = () => {
    setDisplaySendAnotherEmail((prev) => !prev);
    setThankyouPageRedirect(false);
    setUpdateAfterUpload(true);
  };

  const handleChangeDisplayLink = () => {
    setDisplayLink((prev) => !prev);
    setThankyouPageRedirect(false);
    setUpdateAfterUpload(true);
  };

  const handleChangeRedirectLink = (e) => {
    setEmptyOrInvalidUrl(false);
    setRedirectLink(e);
  };

  useEffect(() => {
    if (!thankyouPageRedirect) {
      setRedirectLink("");
    }
  }, [thankyouPageRedirect]);

  useEffect(() => {
    if (updateAfterUpload) {
      setUpdateBeforeSave({ mode: true, action: "updateAfterUploadComplete" });
      setUpdateAfterUpload(false);
    }
  }, [updateAfterUpload]);

  return (
    <div className="after-upload-completes-settings option">
      <div className="checkboxs-container">
        <div className="title-checkboxs">
          <span className="span-title">
            {getTextByKey("display-after-complete")}
          </span>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={() => {
              handleChangeDisplayLink();
            }}
            name={displayLink ? "checkbox-checked" : "checkbox-unchecked"}
            ext="svg"
          />
          <div className="text-and-tooltip">
            <span className="span-text">
              {getTextByKey("display-link-after-upload")}
            </span>{" "}
            <Tooltip
              id={"display-link"}
              tooltipTextKey="display-link-after-upload-tooltip"
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={() => {
              handleChangeSendAnotherEmail();
            }}
            name={
              displaySendAnotherEmail
                ? "checkbox-checked"
                : "checkbox-unchecked"
            }
            ext="svg"
          />
          <div className="text-and-tooltip">
            <span className="span-text">
              {getTextByKey("display-send-another-email")}
            </span>{" "}
            <Tooltip
              id={"send-another-email"}
              tooltipTextKey="display-send-another-email-tooltip"
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={() => {
              handleChangeDeleteMailLink();
            }}
            name={deleteMailLink ? "checkbox-checked" : "checkbox-unchecked"}
            ext="svg"
          />
          <div className="text-and-tooltip">
            <span className="span-text">
              {getTextByKey("delete-mail-link-text")}
            </span>{" "}
            <Tooltip
              id={"delete-mail-link"}
              tooltipTextKey="delete-mail-link-tooltip"
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={(e) => {
              handleChangeThankYouPage();
            }}
            name={
              isPremium()
                ? thankyouPageRedirect
                  ? "checkbox-checked"
                  : "checkbox-unchecked"
                : "checkbox-unchecked"
            }
            ext="svg"
          />
          <div className="text-and-tooltip">
            {" "}
            <span className="span-text">
              {getHtmlByKey("display-thank-you-page")}
            </span>{" "}
            <Tooltip
              id={"redirect-thankyou-page"}
              tooltipTextKey="display-thank-you-page-tooltip"
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
      </div>

      {thankyouPageRedirect && (
        <div className="url-input-container">
          <div className="url-input-title">
            <span className="span-title">{getTextByKey("my-url-address")}</span>
          </div>
          <div
            className={`input-div ${emptyOrInvalidUrl ? "invalid-url" : ""}`}
          >
            <input
              onFocus={(e) => {
                setTempFocuseRedirectUrl(e.target.value);
              }}
              onBlur={(e) => {
                setTempBlurRedirectUrl(e.target.value);
              }}
              value={isPremium() ? redirectLink : ""}
              onChange={(e) => handleChangeRedirectLink(e.target.value)}
              type="text"
            />
          </div>
          {emptyOrInvalidUrl && (
            <div className="invalid-alert-text">
              {getTextByKey("empty-redirect-link")}
            </div>
          )}
          <div className="show-technical-details">
            <LinkToNewTab
              isNewTab
              page={"support/jumbo-embed/thank-you-page-redirect"}
            >
              {getTextByKey("technical-details")}
            </LinkToNewTab>
          </div>
        </div>
      )}
      <div className="radio-options">
        <div className="title-radio">
          <span className="span-title">{getTextByKey("view-mode-title")}</span>
        </div>
        <div className="text-radio">
          <span className="span-text">{getTextByKey("view-mode-text")}</span>
        </div>
        <div className="input-status-div">
          <Image
            alt=""
            title=""
            className="input-checkbox"
            onClick={() => {
              setViewMode("gallery");
            }}
            name={viewMode === "gallery" ? "radio-checked" : "radio-unchecked"}
            ext="svg"
          />
          <span className="input-label span-text">
            {getTextByKey("display-gallery")}
          </span>{" "}
        </div>
        <div className="input-status-div">
          <Image
            alt=""
            title=""
            className="input-checkbox"
            onClick={(e) => {
              setViewMode("list");
            }}
            name={viewMode === "list" ? "radio-checked" : "radio-unchecked"}
            ext="svg"
          />
          <span className="input-label span-text">
            {getTextByKey("display-list")}
          </span>{" "}
        </div>
      </div>
    </div>
  );
};

export default AfterUploadCompletes;
